var config = (function() {
  return {
    "cloudinary": {
      "cloud_name": "merchology",
      "api_key": "866365886173385",
      "api_secret": "yuEMc51Ll-zb1h-fCb9IPdKUI6w",
      "upload_preset": "swakqrq4",
      "secure": true
    }
  }
})()
